import { Component, ElementRef, Injector, QueryList, Renderer2, Signal, ViewChild, ViewChildren, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { authorizedMarshal } from '../../auth/auth.guard';

import { CampaignService } from '../../services/campaign.service';
import { SessionService } from '../../services/session.service';
import { UserService } from '../../services/user.service';

import { Campaign, baseCampaign } from '../../interfaces/campaign';
import { User } from '../../interfaces/user';

@Component({
  selector: 'campaign-edit',
  templateUrl: './campaign-edit.component.html',
  standalone: false
})
export class CampaignEditComponent {
  campaignService = inject(CampaignService);
  injector = inject(Injector);
  route = inject(ActivatedRoute);
  router = inject(Router);
  session = inject(SessionService);
  userService = inject(UserService);

  authorizedMarshal: boolean = authorizedMarshal();
  campaignId: string = "";
  campaign: Campaign;
  campaignToEdit: Campaign;
  users: Signal<User[]> = signal([]);

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.campaignId = params['campaignId'];
      if (this.campaignId === '0') {
        this.campaign = baseCampaign;
        this.session.setCampaign(null);
      }
      else {
        this.campaign = this.session.getCampaign();
      }
      this.campaignToEdit = Object.assign({}, this.campaign);
    });
    this.users = toSignal(this.userService.getSkyMarshals(), { injector: this.injector });
  };

  saveCampaign(campaign: Campaign) {
    this.session.iAmBusy();
    this.campaignService.saveCampaign(campaign).subscribe(() => {
      this.session.setNotifyMessage('Campaign Saved');
      this.session.iAmNotBusy();
      return this.router.navigate(['/user/assignments']);
    });
  };
};
